import { CIcon } from '~/icons/types'

export const ciCaravans: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.447 16.782h-2.325l-.094-2.481h-4.19v2.484h-3.994V14.3H.07v.858a2.615 2.615 0 0 0 2.611 2.61h.54a3.19 3.19 0 0 1 2-2.854 3.19 3.19 0 0 1 3.83 1.158 3.2 3.2 0 0 1 .561 1.7h11.965V18.8a.492.492 0 1 0 .984 0v-1.03h.877a.495.495 0 0 0 .01-.99Z'
    },
    {
      d:
        'M7.247 15.82a2.206 2.206 0 0 0-2.624.768c-.245.344-.387.75-.409 1.172 0 .038-.005.075-.005.113a2.219 2.219 0 0 0 2.215 2.217 2.222 2.222 0 0 0 2.207-2.063c.002-.05.002-.1 0-.15a.837.837 0 0 0 0-.112 2.234 2.234 0 0 0-1.384-1.945Zm5.598-7.89a.49.49 0 0 1 .49-.49h3.01a.49.49 0 0 1 .49.49v5.38H21l-.16-4.27a5.33 5.33 0 0 0-5.32-5.13H3.015a2.938 2.938 0 0 0-2.94 2.94v6.46h12.77V7.93Zm-3.34 3a.555.555 0 0 1-.55.55h-4.93a.41.41 0 0 1-.41-.4l.01-3.24a.4.4 0 0 1 .4-.4h5.08a.4.4 0 0 1 .4.4v3.09Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'caravans',
  type: 'solid'
}
